// @flow

import get from 'lodash/get';
import type { SearchNotification } from './types';
import { NOTIFICACTIONS_MANAGER_STATE } from '../constants';

export const searchNotificationsSelector = (state: Object): SearchNotification<*>[] => {
  const notificationsManagerState = state[NOTIFICACTIONS_MANAGER_STATE];
  return get(notificationsManagerState, 'searchNotifications');
};

export const hasSearchNotificationsSelector = (state: Object): boolean => {
  const searchNotificatins = searchNotificationsSelector(state);
  return searchNotificatins.length !== 0;
};



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/SearchNotifications/selectors.js